"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var is_html_element_1 = require("../is-html-element");
function asHTMLElement(o) {
    if (is_html_element_1.default(o)) {
        return o;
    }
    return null;
}
exports.default = asHTMLElement;
